import { withCloseAfterExited } from "@10duke/dukeui";
import { default as View, ViewDeviceClientModalProps } from "./view-device-client-modal-view";

const ViewDeviceClientModal = withCloseAfterExited<ViewDeviceClientModalProps>(View);
export default ViewDeviceClientModal;
